import * as defaultImport from "@splunk/react-icons/ChevronDown";
export * from "@splunk/react-icons/ChevronDown";
export default ('default' in defaultImport ? defaultImport.default : defaultImport);
